<app-dialog [visible]="visible" (closed)="onHide()" [closable]="false" [showCloseButton]="false"
    class="w-[85vw] h-[90vh] max-w-[90vw] max-h-[95vh] overflow-hidden p-0 flex flex-col stepper-dialog">
    <ng-template #bodyTemplate>
        <div class="flex h-full overflow-hidden">
            <!-- Left Panel: Progress Tracker -->
            <div class="w-1/3 border-r border-gray-200 flex flex-col relative overflow-hidden">
                <div class="absolute top-0 left-0 right-0 h-2/5 z-0 pointer-events-none">
                    <div
                        class="absolute inset-0 bg-[radial-gradient(60%_60%_at_0%_0%,var(--arena-orange-400),transparent_70%)]">
                    </div>
                    <div
                        class="absolute inset-0 bg-[radial-gradient(60%_60%_at_100%_0%,var(--arena-blue-400),transparent_70%)]">
                    </div>
                    <div class="absolute inset-0 backdrop-blur-xl"></div>
                </div>
                <!-- Content (relative for z-index) -->
                <div class="relative z-10 flex flex-col h-full px-12 pt-16">
                    <!-- Title -->
                    <div class="mb-6">
                        <h1 class="text-2xl font-bold theme-text mb-2  font-bricolage">
                            {{ config.title || stepsAwayText() }}
                        </h1>
                        <p class="text-md theme-text font-bricolage">
                            {{ config.subtitle }}
                        </p>
                    </div>

                    <!-- Steps List -->
                    <div class="flex flex-col flex-1">
                        @for(step of stepStatus(); track step.id; let i = $index) {
                        <div class="flex flex-col gap-0">

                            <!-- STEP ROW (this alone gets bg) -->
                            <div class="inline-flex  items-center gap-3 rounded-xl py-3 px-2 cursor-pointer justify-between w-[75%]"
                                [ngClass]="{
                                'backdrop-blur-sm bg-gradient-to-r from-arena-orange-100 to-arena-blue-100': step.status === 'current'
                              }" (click)="goToStep(i)">

                                <div class="flex items-center gap-3">
                                    <!-- LEFT: circle -->
                                    <div class="w-10 flex justify-center">
                                        <div
                                            class="rounded-full w-10 h-10  flex items-center justify-center theme-border">
                                            <span class="theme-text text-lg text-center">
                                                {{ formatStepNumber(i) }}
                                            </span>
                                        </div>

                                    </div>

                                    <div class="text-md theme-text font-sans  font-medium">
                                        {{ step.label }}
                                    </div>
                                </div>
                                <!-- RIGHT: label + icon -->
                                <div class="flex items-center justify-between gap-3">


                                    @if(step.status === 'completed') {
                                    <div class="w-6 h-6 rounded-full bg-green-600 p-2 flex items-center justify-center">
                                        <app-icon type="check" source="lucide" size="sm" class="text-white"></app-icon>
                                    </div>
                                    }
                                    @else if(step.status === 'current') {
                                    <app-icon type="chevron-right" source="lucide" size="xl"
                                        class="theme-text"></app-icon>
                                    }
                                </div>
                            </div>

                            <!-- CONNECTOR (never gets bg) -->
                            @if(i < stepStatus().length - 1) { <div class="flex"
                                [ngClass]="{'pt-1': step.status === 'current'}">
                                <div class="w-14 h-6 flex justify-center items-center">
                                    <div class="w-0.5 h-3 theme-bg"></div>
                                </div>
                        </div>
                        }
                    </div>

                    }
                </div>
            </div>

            <!-- Step Image (if available) -->
            @if(currentStepImage(); as image) {
            <div class="flex-1 h-full flex justify-end items-end relative min-w-0 min-h-0 max-xl:hidden">
                <div class="absolute bottom-0 left-0 right-0 min-h-[100px] h-1/3 z-0">
                    <div class="absolute inset-0 bg-gradient-to-b from-orange-50/20 to-arena-orange-200/50">
                    </div>
                </div>
                <div [innerHTML]="image | sanitizeHtml" class="flex items-center justify-center relative z-10
                           [&>svg]:sm:w-[200px] [&>svg]:sm:h-[180px]
                           [&>svg]:md:w-[240px] [&>svg]:md:h-[200px]
                           [&>svg]:lg:w-[280px] [&>svg]:lg:h-[240px]
                           [&>svg]:xl:w-[240px] [&>svg]:xl:h-[240px]
                           [&>svg]:2xl:w-full [&>svg]:2xl:h-full">
                </div>
            </div>
            }
        </div>

        <!-- Right Panel: Step Content -->
        <div class="flex-1 flex flex-col overflow-hidden bg-white">
            <!-- Step Header with Title, Subtitle, and Close Button -->
            <div class="flex items-start justify-between p-6 pb-4 flex-shrink-0">
                <div class="flex-1">
                    @if(stepperService.currentStep() && stepperService.currentStep()!.title) {
                    <h2 class="text-2xl font-bold text-gray-900 m-0 mb-1">
                        {{ stepperService.currentStep()!.title }}
                    </h2>
                    }
                    @if(stepperService.currentStep() && stepperService.currentStep()!.subtitle) {
                    <p class="text-sm text-gray-600 m-0">
                        {{ stepperService.currentStep()!.subtitle }}
                    </p>
                    }
                </div>
                <!-- Close Button - Always visible -->
                <div class="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0" (click)="onClose()">
                    <app-icon type="x" source="lucide" [size]="'default'" class="hover:cursor-pointer"
                        (clicked)="onClose()"></app-icon>
                </div>
            </div>

            <!-- Scrollable Content Area -->
            <div class="flex-1 overflow-y-auto flex flex-col h-full"
                [ngClass]="stepperService.currentStep()!.contentClass ?? 'px-6'">
                @if(currentStepTemplate()) {
                <ng-container *ngTemplateOutlet="currentStepTemplate()!">
                </ng-container>
                } @else {
                <div class="flex items-center justify-center h-full text-gray-500">
                    <p>No content available for this step</p>
                </div>
                }
            </div>

            <!-- Footer Buttons at Bottom of Right Panel -->
            <div class="p-4 bg-white flex-shrink-0">
                <div class="flex gap-2 items-center w-full"
                    [ngClass]="{'justify-between': !stepperService.isFirstStep(), 'justify-end': stepperService.isFirstStep()}">
                    @if(!stepperService.isFirstStep()) {
                    <app-button label="Previous" variant="outlined" severity="contrast" (clicked)="onPreviousStep()"
                        [disabled]="finishButtonLoading" icon="pi pi-chevron-left">
                    </app-button>
                    }
                    <div class="flex gap-2 items-center">
                        @if(isCurrentStepSkipable()) {
                        <app-button label="Skip" variant="outlined" severity="contrast" (clicked)="onSkipStep()"
                            [disabled]="finishButtonLoading">
                        </app-button>
                        }
                        <app-button variant="filled" severity="primary"
                            [label]="stepperService.isLastStep() ? 'Finish' : 'Next'" (clicked)="onNextStep()"
                            [disabled]="finishButtonLoading || disableNextButton || !canProceedToNext()"
                            [loading]="stepperService.isLastStep() && finishButtonLoading"
                            [icon]="stepperService.isLastStep() ? '' : 'pi pi-chevron-right'" [iconPosition]="'right'">
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </ng-template>
</app-dialog>